import { Component } from 'react';
import styled, { css } from 'styled-components';
import { MdSearch, MdHighlightOff } from 'react-icons/md';
import Animate from 'react-move/Animate';
import { ButtonReset, spacing, color } from 'ui';
import { InputSearch } from 'ui/forms';

const SearchIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${spacing(0.5)};
  padding: ${spacing(0.25)};
  line-height: 0.8;
`;

const CancelableInputContainer = styled.div`
  position: relative;
  display: inline-block;

  ${({ variant }) =>
    variant === 'inSelect' &&
    css`
      position: absolute;
      width: 100%;
      left: 0;

      ${SearchIcon} {
        width: 28px;
        height: 28px;
      }

      ${InputSearch} {
        border: 0;
      }
    `}

  > ${ButtonReset} {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: ${spacing(0.5)};
    display: flex;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }

  svg {
    fill: ${color('black', 'tertiary')};

    &:hover {
      fill: ${color('black', 'secondary')};
    }
  }
`;

class Search extends Component {
  static defaultProps = {
    value: '',
    placeholder: 'Rechercher',
  };

  render() {
    const {
      onChange,
      value,
      onClear,
      secondary,
      variant,
      placeholder,
      style,
    } = this.props;

    return (
      <CancelableInputContainer variant={variant} style={style}>
        <SearchIcon>
          <MdSearch size="20" />
        </SearchIcon>

        <InputSearch
          ref={c => (this.input = c)}
          type="text"
          onChange={onChange}
          value={value}
          secondary={secondary}
          placeholder={placeholder}
          style={style}
        />

        <Animate
          show={Boolean(value)}
          start={{ opacity: 0, translate: 0 }}
          enter={[
            {
              opacity: [1],
              timing: {
                duration: 100,
              },
            },
          ]}
          leave={{
            opacity: [0],
            timing: {
              duration: 100,
            },
          }}
        >
          {({ opacity, translate }) => (
            <ButtonReset
              phantom
              style={{ opacity: `${opacity}` }}
              onClick={onClear}
            >
              <MdHighlightOff size="20" />
            </ButtonReset>
          )}
        </Animate>
      </CancelableInputContainer>
    );
  }
}
export default Search;
